import { infiniteQueryOptions, useInfiniteQuery } from '@tanstack/react-query'
import { fetchRatingsAndReviews } from '@/features/account/services/RatingsAndReviews/fetchers'

const RatingsAndReviewsKey = 'Ratings And Reviews'

export type RatingsAndReviewsQueryKey = readonly [
  typeof RatingsAndReviewsKey,
  Readonly<{
    productId: number
    sortByParam: string
  }>,
]

const ratingsAndReviewsQueryOptions = (productId: number, sortByParam: string) =>
  infiniteQueryOptions({
    queryKey: [RatingsAndReviewsKey, { productId, sortByParam }] as const,
    queryFn: fetchRatingsAndReviews,
    initialPageParam: '',
    getNextPageParam: (lastPage) =>
      lastPage.reviews.length ? (lastPage.pagination.next_cursor ?? undefined) : undefined,
    placeholderData: (previousData) => previousData,
  })

export const useInfiniteRatingsAndReviews = (productId: number, sortByParam: string) => {
  return useInfiniteQuery(ratingsAndReviewsQueryOptions(productId, sortByParam))
}
